import { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext(null);

const STR = {
    id: {
        sponsor_form_t: "Form Pengajuan Sponsor",
        sponsor_form_desc: "Isi data berikut — pengurus klub akan menghubungi Anda untuk info lebih lanjut via WhatsApp.",
        form_name: "Nama / Brand",
        form_contact: "Kontak (WA / Email)",
        form_message: "Pesan (opsional)",
        form_submit: "Kirim Pengajuan",
        form_sending: "Mengirim...",
        form_success: "Pengajuan terkirim! Kami akan segera menghubungi Anda.",
        form_error: "Gagal mengirim. Coba lagi.",
        pengumuman_t: "Pengumuman",
        ch_galeri_t: "Galeri Kegiatan",
        ch_galeri_s: "Latihan & Kejuaraan",
        galeri_empty: "Belum ada foto kegiatan.",
        nav_video: "Video",
        nav_galeri: "Galeri",
        ch_video_t: "Video Kegiatan",
        ch_video_s: "Tonton Kami",
        video_empty: "Belum ada video. Tambahkan lewat dashboard admin.",
        pengumuman_s: "Info Untuk Semua",
        pengumuman_empty: "Belum ada pengumuman.",
        pengumuman_more: "Lihat Selengkapnya",
        pengumuman_less: "Tutup",
        ranking_t: "Papan Peringkat",
        ranking_empty: "Belum ada medali pada kategori ini.",
        filter_all: "Semua",
        rank_athlete: "Atlet",
        rank_total: "Total",
        rank_points: "Poin",
        rank_year: "Tahun",
        rank_points_note: "Poin = medali × bobot tingkat kejuaraan. Emas 3, Perak 2, Perunggu 1. Bobot: Internal Klub ×1, Kota/Kabupaten ×2, Provinsi ×3, Nasional ×4, Internasional ×5. Menampilkan 10 atlet teratas.",
        hero_stat_medals: "Total Medali",
        hero_stat_founded: "Tahun Berdiri",
        nav_coach: "Coach",
        nav_jadwal: "Jadwal",
        ch_coach_t: "Pelatih Kami",
        ch_coach_s: "Tim Pelatih",
        coach_empty: "Belum ada data pelatih.",
        ch_jadwal_t: "Jadwal Latihan",
        ch_jadwal_s: "Rutin Setiap Pekan",
        jadwal_empty: "Belum ada jadwal latihan.",
        nav_coach: "Coach",
        nav_jadwal: "Jadwal",
        ch_coach_t: "Pelatih Kami",
        ch_coach_s: "Tim Pelatih",
        coach_empty: "Belum ada data pelatih.",
        ch_jadwal_t: "Jadwal Latihan",
        ch_jadwal_s: "Rutin Setiap Pekan",
        jadwal_empty: "Belum ada jadwal latihan.",
        nav_prestasi: "Prestasi",
        nav_atlet: "Atlet",
        nav_berita: "Berita",
        nav_gear: "Gear",
        nav_sponsor: "Sponsor",
        nav_parent_portal: "Portal Ortu",
        nav_new_student: "Daftar Siswa Baru",
        nav_gabung: "Gabung",
        nav_gabung_full: "Gabung Klub",
        hero_kicker: "Klub Sepaturoda — Lombok, NTB",
        hero_subtitle:
            "Klub sepaturoda di NTB yang melatih sepaturoda dari pemula hingga meraih prestasi.",
        hero_cta_prestasi: "Lihat Prestasi",
        hero_cta_athletes: "Lihat Atlet",
        hero_cta_gabung: "Gabung Klub",
        marquee_words: ["MANDALIS!", "KUAT!", "BERJUANG!!", "MENANG!!!"],
        ch_prestasi_t: "Prestasi Atlet",
        ch_prestasi_s: "Jejak Medali",
        ch_atlet_t: "Atlet Kami",
        ch_atlet_s: "Skuad Mandalis",
        ch_berita_t: "Berita & Artikel",
        ch_berita_s: "Kabar Terkini",
        ch_gear_t: "Link Rekomendasi Produk",
        ch_gear_s: "Toko Pilihan Klub",
        ch_gabung_t: "Gabung Klub",
        ch_gabung_s: "Jadi Bagian Kami",
        ch_sponsor_t: "Sponsor & Mitra",
        ch_sponsor_s: "Dukung Klub",
        ch_ranking_t: "Papan Peringkat",
        ch_ranking_s: "Peraih Medali Terbanyak",
        ch_category_t: "Papan Skor Kategori",
        ch_category_s: "10 Atlet Teratas",
        category_speed_desc: "Nomor kecepatan di lintasan — sprint, ketahanan, dan catatan waktu terbaik.",
        category_standart_desc: "Nomor standar dengan fokus teknik dasar, konsistensi, dan performa lomba.",
        category_slalom_desc: "Nomor ketangkasan melewati cone dengan kontrol, keseimbangan, dan presisi.",
        atlet_class_other: "Belum Ada Kelas",
        sponsor_interest: "Berminat Menjadi Sponsor",
        prestasi_empty: "Belum ada prestasi yang dipublikasikan.",
        atlet_empty: "Belum ada profil atlet yang dipublikasikan.",
        top_supported_t: "Paling Didukung",
        top_supported_s: "beri love & semangat di profil atlet",
        atlet_view: "Lihat Profil",
        atlet_more: "Lihat Selengkapnya",
        atlet_born: "Lahir",
        atlet_since: "Sejak",
        berita_read: "Baca Artikel",
        berita_empty: "Belum ada berita yang dipublikasikan.",
        gear_desc:
            "Perlengkapan yang tepat menentukan performa di lintasan. Berikut tautan toko rekomendasi pelatih untuk sepaturoda, pelindung, dan sparepart.",
        gear_empty: "Belum ada rekomendasi toko.",
        gabung_heading_1: "Siap melaju",
        gabung_heading_2: "bersama kami?",
        gabung_desc:
            "Terbuka untuk semua usia dan level — dari pemula yang baru belajar berdiri di atas roda hingga skater yang membidik podium. Isi formulir pendaftaran atau hubungi pengurus langsung.",
        gabung_form: "Formulir Pendaftaran",
        gabung_follow: "Ikuti Kami",
        sponsor_headline: "Mari Tumbuh & Berjuang Bersama Kami",
        sponsor_desc:
            "Kami tidak datang hanya untuk meminta dukungan. Kami datang untuk menawarkan sebuah kerja sama yang saling memberikan nilai. Dengan jumlah atlet dan keluarga besar yang terus bertumbuh, serta perjalanan Mandalika Inline Skate yang telah dikenal dan berprestasi di tingkat NTB, nasional, hingga internasional, kami memiliki komunitas dan jangkauan yang dapat menjadi ruang bagi brand Anda untuk tumbuh bersama kami. Setiap dukungan yang diberikan akan kami balas dengan eksposur, publikasi, dan benefit yang sepadan, sesuai dengan bentuk dan nilai sponsorship yang diberikan. Lebih dari sekadar menampilkan logo, kami ingin membawa brand Anda menjadi bagian dari perjalanan para atlet kami—anak-anak dari sebuah pulau kecil yang berani membawa mimpi mereka ke panggung yang lebih besar.",
        sponsor_tagline: "Brand Anda bukan sekadar sponsor. Brand Anda adalah bagian dari perjalanan mereka.",
        sponsor_closing: "Mari bekerja sama. Dukung atletnya. Tumbuh bersama komunitasnya. Bawa brand Anda dalam setiap langkah menuju prestasi.",
        sponsor_monthly: "Bulanan",
        sponsor_yearly: "Tahunan",
        sponsor_cta: "Daftar Sponsor",
        pkg_monthly_tag: "Untuk brand yang ingin hadir cepat",
        pkg_yearly_tag: "Kemitraan penuh satu musim kompetisi",
        pkg_monthly_benefits: [
            "Logo di kolom sponsor website",
            "Sebutan di konten media sosial klub",
            "Review produk gratis di story Instagram Mandalis",
        ],
        pkg_yearly_benefits: [
            "Semua benefit paket bulanan",
            "Logo pada jersey & perlengkapan tim",
            "Brand exposure di setiap kejuaraan yang diikuti",
            "Prioritas kolaborasi event bersama klub",
        ],
        footer_tagline: "Klub sepaturoda Lombok, NTB. Melaju lebih cepat, bersama.",
        footer_rights: "© 2026 Mandalika Inlineskate. Lombok, Nusa Tenggara Barat.",
        back: "Kembali",
        back_home: "Kembali ke Beranda",
        article_notfound: "Artikel tidak ditemukan",
        athlete_notfound: "Atlet tidak ditemukan",
        athlete_profile: "Profil Atlet",
        athlete_birth: "Tahun Lahir",
        athlete_joined: "Di Mandalis Sejak",
        athlete_specialty: "Spesialisasi",
        athlete_history: "Riwayat Medali",
        athlete_history_empty:
            "Belum ada medali tercatat. Medali akan muncul otomatis saat prestasi atlet ini ditambahkan.",
    },
    en: {
        ch_galeri_t: "Activity Gallery",
        ch_galeri_s: "Training & Championships",
        galeri_empty: "No activity photos yet.",
        nav_video: "Videos",
        nav_galeri: "Gallery",
        ch_video_t: "Activity Videos",
        ch_video_s: "Watch Us",
        video_empty: "No videos yet. Add one from the admin dashboard.",
        sponsor_form_t: "Sponsorship Inquiry Form",
        sponsor_form_desc: "Fill in the details below — our team will contact you via WhatsApp for more information.",
        form_name: "Name / Brand",
        form_contact: "Contact (WA / Email)",
        form_message: "Message (optional)",
        form_submit: "Submit Inquiry",
        form_sending: "Sending...",
        form_success: "Inquiry sent! We will contact you shortly.",
        form_error: "Failed to send. Please try again.",
        pengumuman_t: "Announcements",
        pengumuman_s: "For Everyone",
        pengumuman_empty: "No announcements yet.",
        pengumuman_more: "Read More",
        pengumuman_less: "Close",
        ranking_t: "Leaderboard",
        ranking_empty: "No medals in this category yet.",
        filter_all: "All",
        rank_athlete: "Athlete",
        rank_total: "Total",
        rank_points: "Points",
        rank_year: "Year",
        rank_points_note: "Points = medals × championship level weight. Gold 3, Silver 2, Bronze 1. Weights: Club Internal ×1, City/Regency ×2, Province ×3, National ×4, International ×5. Showing the top 10 athletes.",
        hero_stat_medals: "Total Medals",
        hero_stat_founded: "Established",
        nav_coach: "Coaches",
        nav_jadwal: "Schedule",
        ch_coach_t: "Our Coaches",
        ch_coach_s: "Coaching Team",
        coach_empty: "No coaches yet.",
        ch_jadwal_t: "Training Schedule",
        ch_jadwal_s: "Weekly Routine",
        jadwal_empty: "No training schedule yet.",
        nav_coach: "Coaches",
        nav_jadwal: "Schedule",
        ch_coach_t: "Our Coaches",
        ch_coach_s: "Coaching Team",
        coach_empty: "No coaches yet.",
        ch_jadwal_t: "Training Schedule",
        ch_jadwal_s: "Weekly Routine",
        jadwal_empty: "No training schedule yet.",
        nav_prestasi: "Achievements",
        nav_atlet: "Athletes",
        nav_berita: "News",
        nav_gear: "Gear",
        nav_sponsor: "Sponsors",
        nav_parent_portal: "Parent Portal",
        nav_new_student: "New Student Registration",
        nav_gabung: "Join",
        nav_gabung_full: "Join the Club",
        hero_kicker: "Inline Skate Club — Lombok, Indonesia",
        hero_subtitle:
            "Home of Lombok's skaters. Skating faster, winning medals, and building a community in the land of a world-class circuit.",
        hero_cta_prestasi: "View Achievements",
        hero_cta_athletes: "View Athletes",
        hero_cta_gabung: "Join the Club",
        marquee_words: ["MANDALIS!", "KUAT!", "BERJUANG!!", "MENANG!!!"],
        ch_prestasi_t: "Athlete Achievements",
        ch_prestasi_s: "Medal Track Record",
        ch_atlet_t: "Our Athletes",
        ch_atlet_s: "The Mandalis Squad",
        ch_berita_t: "News & Articles",
        ch_berita_s: "Latest Updates",
        ch_gear_t: "Recommended Product Links",
        ch_gear_s: "Club's Trusted Shops",
        ch_gabung_t: "Join the Club",
        ch_gabung_s: "Be Part of Us",
        ch_sponsor_t: "Sponsors & Partners",
        ch_sponsor_s: "Support the Club",
        ch_ranking_t: "Leaderboard",
        ch_ranking_s: "Top Medalists",
        ch_category_t: "Category Scoreboard",
        ch_category_s: "Top 10 Athletes",
        category_speed_desc: "Track speed events — sprinting, endurance, and the best recorded times.",
        category_standart_desc: "Standard events focused on core technique, consistency, and race performance.",
        category_slalom_desc: "Agility events through cones with control, balance, and precision.",
        atlet_class_other: "No Class Yet",
        sponsor_interest: "Become a Sponsor",
        prestasi_empty: "No achievements published yet.",
        atlet_empty: "No athlete profiles published yet.",
        top_supported_t: "Most Supported",
        top_supported_s: "send love & cheers on the athlete's profile",
        atlet_view: "View Profile",
        atlet_more: "See All",
        atlet_born: "Born",
        atlet_since: "Since",
        berita_read: "Read Article",
        berita_empty: "No news published yet.",
        gear_desc:
            "The right gear defines your performance on the track. Here are the coach-recommended shops for skates, protection, and spare parts.",
        gear_empty: "No shop recommendations yet.",
        gabung_heading_1: "Ready to roll",
        gabung_heading_2: "with us?",
        gabung_desc:
            "Open to all ages and levels — from beginners learning to stand on wheels to skaters chasing the podium. Fill in the registration form or contact our team directly.",
        gabung_form: "Registration Form",
        gabung_follow: "Follow Us",
        sponsor_headline: "Let's Grow & Fight Together",
        sponsor_desc:
            "We do not come only to ask for support. We come to offer a partnership that gives value to both sides. With a growing number of athletes and a big family behind them, and with Mandalika Inline Skate's journey that is recognized and accomplished at the NTB, national, and international levels, we have a community and a reach that can become a space for your brand to grow together with us. Every support given will be repaid with exposure, publication, and benefits that match the form and value of the sponsorship. More than just displaying a logo, we want to bring your brand into the journey of our athletes—children from a small island who dare to carry their dreams to a bigger stage.",
        sponsor_tagline: "Your brand is not just a sponsor. Your brand is part of their journey.",
        sponsor_closing: "Let's work together. Support the athletes. Grow with the community. Carry your brand in every step towards achievement.",
        sponsor_monthly: "Monthly",
        sponsor_yearly: "Yearly",
        sponsor_cta: "Register as",
        pkg_monthly_tag: "For brands that want quick exposure",
        pkg_yearly_tag: "A full season partnership",
        pkg_monthly_benefits: [
            "Logo in the website sponsor slot",
            "Mention in club social media content",
            "Free product review on the Mandalis Instagram story",
        ],
        pkg_yearly_benefits: [
            "All monthly package benefits",
            "Logo on team jersey & equipment",
            "Brand exposure at every championship we enter",
            "Priority for event collaborations with the club",
        ],
        footer_tagline: "Inline skate club of Lombok, Indonesia. Faster, together.",
        footer_rights: "© 2026 Mandalika Inlineskate. Lombok, West Nusa Tenggara.",
        back: "Back",
        back_home: "Back to Home",
        article_notfound: "Article not found",
        athlete_notfound: "Athlete not found",
        athlete_profile: "Athlete Profile",
        athlete_birth: "Birth Year",
        athlete_joined: "With Mandalis Since",
        athlete_specialty: "Specialty",
        athlete_history: "Medal History",
        athlete_history_empty:
            "No medals recorded yet. Medals appear automatically once this athlete's achievements are added.",
    },
};

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem("mis_lang") || "id");

    useEffect(() => {
        localStorage.setItem("mis_lang", lang);
    }, [lang]);

    return <LangContext.Provider value={{ lang, setLang, t: STR[lang] }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
